export default __webpack_public_path__ + "static/media/grayExtraSmall.6b9dfad2.svg";